import { httpClient } from '@/modules/common/services/http/http-client';
import {
  IConcludedOrdersParams,
  IConcludedOrders,
  IOpenedOrders
} from './types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/transactions`
});

export function getConcludedOrders(
  portfolioId: string,
  params: IConcludedOrdersParams = { page: 1 }
): Promise<IConcludedOrders> {
  return http.get(`/v2/orders/portfolio/${portfolioId}`, { params });
}

export function getOpenedOrders(portfolioId: string): Promise<IOpenedOrders> {
  return http.get(`/v2/orders/portfolio/${portfolioId}/openned`);
}
